module.exports = __webpack_public_path__ + "img/iomico__logo.5685e97a.svg";